// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"8969aaf5","321":"9b413dfa","494":"3aba8220","617":"f2f875b7"}[chunkId] + ".css";
};